import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Modal, Trans } from "components";

export const DataSubmissionBarConfirmationModal = ({
  showConfirmationModal,
  setShowConfirmationModal,
  isSubmitting,
  setIsSubmitting,
  onSubmitClick,
}: {
  showConfirmationModal: boolean;
  setShowConfirmationModal: (show: boolean) => void;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
  onSubmitClick?: () => Promise<void>;
}) => {
  const { t } = useTranslation(["allFieldView"]);

  const handleSubmitClick = async () => {
    setIsSubmitting(true);
    await onSubmitClick?.();
    setIsSubmitting(false);
    setShowConfirmationModal(false);
  };

  return (
    <Modal
      showModal={showConfirmationModal}
      onCancel={() => setShowConfirmationModal(false)}
      onOk={handleSubmitClick}
      title={t("submissionBar.confirmationModal.title")}
      okText={t("submissionBar.confirmationModal.submit")}
      cancelText={t("submissionBar.confirmationModal.cancel")}
      className="submission-bar-confirmation-modal"
      loading={isSubmitting}
      destroyOnHidden
      content={
        <Flex vertical gap="1rem">
          <p className="margin-0">
            <Trans i18nKey={"allFieldView:submissionBar.confirmationModal.description"} components={{ strong: <strong /> }} />
          </p>
          <Flex className="submission-bar-confirmation-modal-info-banner" align="flex-start" justify="space-between" gap="0.5rem">
            <Icon iconName="tabler/info-circle" />
            <div>
              <ul>
                <li>
                  <p className="margin-0">
                    <Trans i18nKey={"allFieldView:submissionBar.confirmationModal.infoPoints.higherPayout"} components={{ strong: <strong /> }} />
                  </p>
                </li>
                <li>
                  <p className="margin-0">
                    <Trans i18nKey={"allFieldView:submissionBar.confirmationModal.infoPoints.lockAssessments"} components={{ strong: <strong /> }} />
                  </p>
                </li>
              </ul>
            </div>
          </Flex>
          <span className="line-divider" />
          <p className="paragraph-m margin-0">{t("submissionBar.confirmationModal.footer")}</p>
        </Flex>
      }
    />
  );
};
